<template>
  <div class="page px-3">
    <div class="title d-flex justify-content-between align-items-center">
<!--      <h3 class="m-3 fw-bold">Dashboard</h3>-->
<!--      <div>-->
<!--        <select v-model="selectedWallet" @change="filterCards" class="form-select">-->
<!--          <option value="" disabled>Select Wallet</option>-->
<!--          <option v-for="wallet in user.wallets" :key="wallet.id" :value="wallet.id">-->
<!--            {{ wallet.wallet_name }}-->
<!--          </option>-->
<!--        </select>-->
<!--      </div>-->
    </div>

    <!-- Second Modal -->
    <div class="modal fade" id="secondModal" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1"
         aria-labelledby="staticMainDebtorBackdrop1Label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="secondModalLabel">Deny Request</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-2">
              <label for="Reason" class="fw-bold">Reason</label>
              <input type="text" placeholder="Reason" class="form-control" id="Reason" v-model="reason">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="DenyRequest">Deny</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs for User Requests and Wallet Requests -->
    <div class="tabs">
      <button :class="{'active': activeTab === 'user'}" @click="setTab('user')">User Requests</button>
      <button :class="{'active': activeTab === 'wallet'}" @click="setTab('wallet')">Wallet Requests</button>
    </div>

    <div class="section">
      <div style="width:100%; display:flex; justify-content: space-between; align-items:center">
        <div class="total" style="width: fit-content; display:flex; justify-content: center; align-items:center; gap: 10px">
          <h4 v-if="activeTab === 'wallet'"
              :class="{'attention-required': totalAmount > 0}">
            Total : {{ $utils.formatMoney(totalAmount) }}
          </h4>
          <h4 v-if="activeTab === 'user'"
              :class="{'attention-required': totalAmount > 0}">
            Total : {{ $utils.formatMoney(totalAmount) }}
          </h4>

<!--          <div>-->
<!--            <select v-model="selectedWallet" @change="filterCards" class="form-select">-->
<!--              <option value="" disabled>Select Wallet</option>-->
<!--              <option v-for="wallet in user.wallets" :key="wallet.id" :value="wallet.id">-->
<!--                {{ wallet.wallet_name }}-->
<!--              </option>-->
<!--            </select>-->
<!--          </div>-->
        </div>

        <ApproveButton
            buttonText="Batch"
            @click="showApproveModal(); refillVueTable();"
        />
      </div>
      <div class="row gap-1">
        <div class="card col-md-4"
             v-for="(item, index) in filteredCardData"
             :key="index"
        >
          <div>
            <div
                class="manager"
                v-if="item.approved_manager !== null"
            >
              <h6 class="h6-tag">Approved by: {{ item.approved_manager}}</h6>
            </div>
            <div class="d-flex flex-row justify-content-between">
<!--              <button @click="checker(item)">CHECK</button>-->
              <div class="d-flex flex-column mx-3" v-if="item.hasImage">
                <img src="../assets/img/no-image.png" v-gallery
                     :data-large="pettyCashApi+`getImageByRequestID/${item.id}`" alt="Product Image" width="60"
                     height="60"/>
                <span class="text-secondary " style="font-size: 12px">(Click to View)</span>
              </div>
              <div class="d-flex flex-column">
                <span class="text-secondary"><strong>ID:</strong> {{ item.id }}</span>
                <p>{{ item.subType }}</p>
                <p>{{ item.requestedWallet }}</p>
              </div>
              <a @click="acceptRequestOnlyExpense(item)">
                <font-awesome-icon icon="money-bill"/>
              </a>
            </div>
            <div class="product-info">
              <div class="price">{{ $utils.formatMoney(item.amount) }}</div>
              <span v-if="item.reference">{{ item.reference }}<br>({{ item.provider }})</span>
            </div>
          </div>
          <div class="card-body d-flex flex-column">
            <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestBy">{{ item.requestBy }}</span>
            <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestedBy">{{ item.requestedBy }}</span>
            <span class="card-text mb-1" v-if="activeTab === 'user'"><strong>Department:</strong> {{ item.department }}</span>
            <span class="card-text mb-1"><strong>Reason:</strong> {{ item.reason }}</span>
            <span v-if="activeTab === 'user'" class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
            <span v-if="item.ticket" class="card-text my-2">
              <a @click="viewticket(item)">
              <strong>Ticket #</strong>{{ item.ticket }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
            <span v-if="item.purchaseOrder" class="card-text my-2">
              <a @click="viewPurchaseOrder(item)">
              <strong>Purchase Order #</strong>{{ item.purchaseOrder }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
            <span v-if="activeTab === 'wallet'" class="card-text"><strong>Date:</strong> {{ item.request_date }}</span>
          </div>
          <div class="d-flex flex-row justify-content-evenly">
            <button type="button" class="btn text-center w-50 mx-2 btn-success" @click="AcceptRequest(item)">Accept
            </button>
            <button type="button" class="btn text-center w-50 btn-danger" @click="DenyRequest(item)">Deny</button>
          </div>
          <div class="d-flex justify-content-center mt-2">
            <button
                class="btn btn-sm btn-warning w-100"
                :disabled="item.status === 'RETRYING'"
                @click.stop="retryFailedRequest(item)"
            >
              {{ item.status === 'RETRYING' ? 'Retrying...' : 'Retry Payment' }}
            </button>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal -->
    <div class="modal fade" id="staticMainDebtorBackdrop1" data-bs-backdrop="false" data-bs-keyboard="false"
         tabindex="-1" aria-labelledby="staticMainDebtorBackdrop1Label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" id="staticMainDebtorBackdrop1Label">Pay Expense</h6>
            <button type="button" class="btn-close" id="close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="selectedCard">
              <p v-if="activeTab === 'user'"><strong>Subtype:</strong> {{ selectedCard.subType }}</p>
              <p v-if="activeTab === 'user'"><strong>DEPARTMENT:</strong> {{ selectedCard.department }}</p>
              <p><strong>ID:</strong> {{ selectedCard.id }}</p>
              <p><strong>Amount:</strong> {{ selectedCard.amount }}</p>
              <p><strong>Reason:</strong> {{ selectedCard.reason }}</p>
              <p v-if="activeTab === 'user'"><strong>Requested-By:</strong> {{ selectedCard.requestBy }}</p>
              <p v-if="activeTab === 'wallet'"><strong>Requested-By:</strong> {{ selectedCard.requestedBy }}</p>
              <p v-if="activeTab === 'user'"><strong>Phone Number:</strong> {{ selectedCard.reference }}</p>
              <p v-if="activeTab === 'user'"><strong>Date Requested:</strong> {{ selectedCard.requestDate }}</p>
              <p v-if="activeTab === 'wallet'"><strong>Date Requested:</strong> {{ selectedCard.request_date }}</p>
              <button type="button" class="btn btn-primary" @click="viewticket" v-if="selectedCard.type === 'JOBCARD'">
                view Ticket
              </button>
              <button type="button" class="btn btn-primary" @click="openimage">view-image</button>
            </div>
          </div>
          <div class="modal-footer">

          </div>
        </div>
      </div>
    </div>

    <floating-add-button v-if="activeTab === 'user'" @click="showFilterModal"/>
    <MakeWalletRequest v-if="activeTab === 'wallet'" :selectedWallet="selectedWallet" :wallets="wallets"/>


    <button class="hide" id="openCard" data-bs-toggle="modal" data-bs-target="#staticMainDebtorBackdrop1"></button>
    <div v-if="approveAllModal" class="modal-overlay">
      <div class="modal-content form-container">
          <div class="modal-header" v-if="isMobileView">
          <ApproveButton
              style="margin-right: 5px"
              :buttonText="isLoading ? 'Processing...' : 'Process'"
              :disabled="isLoading"
              @click="approveAll"
          />
          <ApproveButton
              buttonText="Close"
              buttonColor="black"
              hoverColor="#c82333"
              hoverTextColor="#ffffff"
              @click="closeApproveModal"
          />
          <div style="margin-left: 10px">
            <label>
              <input
                  type="checkbox"
                  v-model="selectAll"
                  @change="toggleSelectAll"
              />
              All
            </label>
          </div>
        </div>
        <div class="modal-bodyy">
          <div v-if="isMobileView" class="card-container">
            <div class="card col-md-4"
                 style="width: 100%"
                 v-for="(item, index) in refillTableData"
                 :key="index"
            >
              <div>
                <div
                    class="manager"
                    v-if="item.approved_manager !== null"
                >
                  <h6 class="h6-tag">Approved by: {{ item.approved_manager}}</h6>
                </div>
                <div class="d-flex flex-row justify-content-between">
                  <div class="d-flex flex-column">
                    <p>{{ item.subType }}</p>
                  </div>
                  <div class="d-flex flex-column mx-3">
                    <img
                        v-if="item.massage === 'Success'"
                        src="@/assets/img/check.png"
                        alt="Success"
                        class="img"
                    />
                    <img
                        v-else-if="item.massage && item.massage !== 'Success'"
                        src="@/assets/img/cancel.png"
                        alt="Error"
                        class="img"
                    />
                    <button
                        class="btn btn-sm btn-warning mt-1"
                        :disabled="item.status === 'RETRYING'"
                        @click.stop="retryFailedRequest(item)"
                    >
                      {{ item.status === 'RETRYING' ? 'Retrying...' : 'Retry' }}
                    </button>
                  </div>
                  <div class="card-item">
                    <label>
                      <input
                          type="checkbox"
                          :value="item.id"
                          v-model="selectedIds"
                      />
                      Select
                    </label>
                  </div>
                </div>
                <div class="product-info">
                  <div class="price">{{ $utils.formatMoney(item.amount) }}</div>
                </div>
              </div>
              <div class="card-body d-flex flex-column" style="padding: 1px">
                <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestBy">{{ item.requestBy }}</span>
                <span class="fw-bolder mb-1" style="font-size: 20px" v-if="item.requestedBy">{{ item.requestedBy }}</span>
                <span class="card-text mb-1"><strong>Reason:</strong> {{ item.reason }}</span>
                <span v-if="activeTab === 'user'" class="card-text"><strong>Date:</strong> {{ item.requestDate }}</span>
                <span class="card-text mb-1" v-if="item.massage"><strong>Massage:</strong> {{ item.massage }}</span>
                <span v-if="item.ticket" class="card-text my-2">
              <a @click="viewticket(item)">
              <strong>Ticket #</strong>{{ item.ticket }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
                <span v-if="item.purchaseOrder" class="card-text my-2">
              <a @click="viewPurchaseOrder(item)">
              <strong>Purchase Order #</strong>{{ item.purchaseOrder }}
                <font-awesome-icon icon="external-link"/>
              </a>
            </span>
                <span v-if="activeTab === 'wallet'" class="card-text"><strong>Date:</strong> {{ item.request_date }}</span>
              </div>
            </div>
          </div>
          <vue-good-table
              v-else
              :columns="columns2"
              :rows="refillTableData"
              @on-selected-rows-change="selectionChanged"
              :search-options="{ enabled: true }"
              :select-options="{ enabled: true }"
              :pagination-options="{ enabled: true, perPage: 6 }"
              class="mt-2"
          >
            <!-- Custom slot for the images column -->
            <template slot="table-row" slot-scope="props">
              <!-- Render images in the custom 'status' column -->
              <td v-if="props.column.field === 'image'">
                <img
                    v-if="props.row.massage === 'Success'"
                    src="@/assets/img/check.png"
                    alt="Success"
                    class="img"
                />
                <img
                    v-else-if="props.row.massage && props.row.massage !== 'Success'"
                    src="@/assets/img/cancel.png"
                    alt="Error"
                    class="img"
                />
                <button
                    class="btn btn-sm btn-warning mt-1"
                    :disabled="props.row.status === 'RETRYING'"
                    @click.stop="retryFailedRequest(props.row)"
                >
                  {{ props.row.status === 'RETRYING' ? 'Retrying...' : 'Retry' }}
                </button>
              </td>
              <!-- Render default content for other columns -->
              <td v-else>
                {{ props.formattedRow[props.column.field] }}
              </td>
            </template>

            <div slot="selected-row-actions">
              <ApproveButton
                  buttonText="Approve selected"
                  :disabled="isLoading"
                  @click="approveAll"
              />
            </div>
          </vue-good-table>
          <ApproveButton
              v-if="!isMobileView"
              buttonText="Close"
              buttonColor="black"
              hoverColor="#c82333"
              hoverTextColor="#ffffff"
              @click="closeApproveModal"
          />
        </div>
        <div class="total-amount" style="font-size: 18px; font-weight: bold; margin-bottom: 10px;">
          Total Amount: {{ $utils.formatMoney(totalSelectedAmount) }}
        </div>
        <div v-if="isLoading" class="overlay">
          <section class="dots-container">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </section>
        </div>
      </div>
    </div>

    <div v-if="filterModal" class="modal-overlay">
      <div class="modal-content form-container">
        <div class="modal-header" >
          <h3>Select Your Filter Parameters</h3>
        </div>
        <div class="modal-bodyy">
          <div class="filter">
            <select
                class="form-select"
                id="floatingSelect"
                aria-label="Floating label select example"
                v-model="selectedDepartment"
            >
              <option disabled value="" style="margin-top: 10px">Select Department</option>
              <option value="all" style="margin-top: 10px">All Departments</option>
              <option
                  v-for="role in dept"
                  :key="role.id"
                  :value="role.name"
              >
                {{ role.name }}
              </option>
            </select>
            <select
                style="margin: 5px;"
                id="department"
                class="form-control"
                v-model="selectedOffice"
            >
              <option disabled value="" style="margin-top: 10px">Select Office</option>
              <option value="all" style="margin-top: 10px">All Offices</option>
              <option v-for="dept in allOffices" :key="dept.id" :value="dept.name">
                {{ dept.name }}
              </option>
            </select>
          </div>
          <div class="filter">
            <select v-model="selectedWallet" @change="filterCards" class="form-select">
              <option value="" disabled>Select Wallet</option>
              <option v-for="wallet in user.wallets" :key="wallet.id" :value="wallet.id">
                {{ wallet.wallet_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="flexy">
          <ApproveButton
              buttonText="Check Results"
              hoverTextColor="#ffffff"
              @click="closeFilterModal"
          />
          <ApproveButton
              buttonText="Reset"
              hoverTextColor="#ffffff"
              @click="reset"
          />
        </div>
        <div v-if="isLoading" class="overlay">
          <section class="dots-container">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </section>
        </div>
      </div>
    </div>
<!--    <Filter v-if="activeTab === 'user'" @click="openuser"/>-->
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import {VueGoodTable} from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import FloatingAddButton from "@/components/layout/utils/FilterButton.vue";
import {utils as $utils} from "../Services/utils";
import axios from "axios";
import {Storage} from "@/Services/Storage";
import MakeWalletRequest from "@/views/MakeWalletRequest.vue";
import ApproveButton from "@/components/buttons/ApproveButton.vue"
import Filter from '@/components/layout/utils/FilterButton.vue'

export default {
  name: "UserRequests",
  computed: {
    totalAmount() {
      return this.filteredCardData.reduce((total, card) => total + (card.amount || 0), 0);
    },
    totalSelectedAmount() {
      return this.refillTableData
          .filter(item => this.selectedIds.includes(item.id))
          .reduce((sum, item) => sum + item.amount, 0);
    },
    $utils() {
      return $utils;
    }
  },
  beforeMount() {
    this.storeSelectedWallet();
    this.getLoggedInUser();
    this.initializeData();

  },
  components: {
    Filter,
    MakeWalletRequest,
    FloatingAddButton,
    ApproveButton,
    VueGoodTable,
  },
  data() {
    return {
      selectedDepartment: 'all',
      selectedOffice: 'all',
      dept: [],
      allOffices: [],
      filterModal: false,
      isLoading: false,
      selectAll: false,
      isMobileView: false,
      processingRequests: [],
      mainCards: true,
      massage: '',
      status: false,
      approveAllModal: false,
      showFloatingButton: true, // Controls the visibility of the button
      formData: {},
      activeTab: 'wallet', // Default to 'wallet' tab
      requestsToApprove: [],
      user: {
        Username: 'Null',
        id: 'Null',
        office: '',
        wallets: [],
      },
      reason: '',
      wallets: [],
      selectedWallet: '',
      pettyCashApi: ticketApi2,
      cardData: {
        user: [], // Data for user requests
        wallet: [] // Data for wallet requests
      },
      filteredCardData: [],
      refillTableData: [],
      selectedCard: null,
      denyReason: '', // For storing the reason of denial
      isFetching: false, // Flag to prevent multiple fetches
      sendWallet: '',
      columns2: [
        {label: "ID", field: "id", sortable: true},
        {label: "Type", field: "type", sortable: true},
        {label: "Amount", field: "amount", sortable: true},
        {label: "Approved manager", field: "approved_manager", sortable: true},
        {label: "Reason", field: "reason", sortable: true},
        {label: "Status", field: "status", sortable: true},
        {label: "Massage", field: "massage", sortable: true},
        {label: "State", field: "image", sortable: true},
      ],
      selectedIds: [],
    };
  },
  created() {
    this.getDepartments();
    this.getOffices();
  },
  methods: {
    checker(item) {
      console.log(item);
    },
    showFilterModal() {
      this.filterModal = true;
    },
    closeFilterModal() {
      this.filterCards();
      this.filterModal = false;
    },
    reset() {
      this.selectedDepartment = 'all';
      this.selectedOffice = 'all';
      this.filterCards();
      this.filterModal = false;
    },
    toggleSelectAll() {
      if (this.selectAll) {
        // Select all IDs
        this.selectedIds = this.refillTableData.map((row) => row.id);
      } else {
        // Deselect all IDs
        this.selectedIds = [];
      }
    },
    processSelected() {
      // Logic for processing selected IDs
      alert(this.selectedIds);
    },
    checkMobileView() {
      this.isMobileView = window.innerWidth <= 768;
    },
    selectionChanged(event) {
      if (event && Array.isArray(event.selectedRows)) {
        this.selectedIds = event.selectedRows.map(row => row.id);
      } else {
        console.error("Unexpected format for selectedRows:", event);
        this.selectedIds = []; // Reset if the input is not valid
      }
    },
    showApproveModal() {
      this.approveAllModal = true;
    },
    closeApproveModal() {
      this.approveAllModal = false;
    },
    openuser() {
      this.$router.push({name: 'SelectRequest'});

    },
    getOffices() {
      axios.get(`${synergyApi}employee/getOffices`)
          .then(response => {
            this.allOffices = response.data;
            console.log(this.allOffices);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          });
    },
    getDepartments() {
      axios.get(`${synergyApi}employee/getAllDepartments`)
          .then(response => {
            this.dept = response.data; // Ensure this is an array
            console.log(this.dept);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          });
    },
    openwallet() {
      this.$router.push({name: 'wallet'});

    },
    async initializeData() {
      await this.getLoggedInUser(); // Ensure user data is fetched first
      await this.getwallets(); // Call getwallets after user data is set
      this.filterCards(); // Fetch and filter cards based on default tab
    },
    closem() {
      const closeButton = document.getElementById('close');
      if (closeButton) {
        closeButton.click();
      }
    },
    async getwallets() {
      this.$utils.showLoading();
      try {
        const response = await axios.get(ticketApi2 + 'get-all-wallets');
        this.wallets = response.data;
        console.log('Wallets:', this.wallets);

        // Set the first wallet as the default selected wallet
        if (this.wallets.length > 0) {
          // this.selectedWallet = this.wallets[0].id;
          this.filterCards(); // Fetch and filter cards based on the default wallet
        }
      } catch (error) {
        console.error('Error fetching wallets:', error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    async approveAll() {
      if (this.isLoading) return;
      const selectedData = this.refillTableData.filter(row =>
          this.selectedIds.includes(row.id)
      );
      if (selectedData.length === 0) {
        Swal.fire({
          icon: 'info',
          title: 'No Requests Selected',
          text: 'Please select at least one request to process.',
          confirmButtonText: 'OK'
        });
        return;
      }

      this.isLoading = true;
      try {
        await this.approveAllUsingBulkEndpoint(selectedData);
      } catch (error) {
        if (this.isBulkEndpointUnavailable(error)) {
          await this.approveAllLegacy(selectedData);
        } else {
          return errorHandler.tomcatError(error);
        }
      } finally {
        this.mainCards = true;
        await this.filterCards();
        console.log("All API calls completed", this.refillTableData);
        this.isLoading = false;
      }
    },
    async approveAllUsingBulkEndpoint(selectedData) {
      const startUrl = `${ticketApi2}transaction-handler/approve-user-request/bulk`;
      const requestBody = {
        requestIds: selectedData.map(item => item.id),
        approvedBy: this.user.username,
        onlyExpense: false,
        maxParallelism: 4,
      };

      const {data} = await axios.post(startUrl, requestBody);
      const jobId = data?.jobId;
      if (!jobId) {
        throw new Error('Bulk approval did not return a job id.');
      }

      const jobResult = await this.pollBulkApprovalJob(jobId, selectedData);
      if (jobResult?.failed > 0) {
        responses.showInfo(`Bulk processing completed with ${jobResult.failed} failed request(s).`);
      } else {
        responses.showInfo(`Bulk processing completed successfully.`);
      }
    },
    async pollBulkApprovalJob(jobId, selectedData) {
      const statusUrl = `${ticketApi2}transaction-handler/approve-user-request/bulk/${jobId}`;
      const rowMap = new Map(selectedData.map(item => [item.id, item]));
      const maxPolls = 180;

      for (let attempt = 0; attempt < maxPolls; attempt++) {
        const {data} = await axios.get(statusUrl);
        const items = data?.items || [];
        items.forEach(item => this.applyBulkItemStatus(item, rowMap));

        if (data?.status === 'COMPLETED') {
          return data;
        }
        await new Promise(resolve => setTimeout(resolve, 1000));
      }

      throw new Error('Bulk approval job timed out while waiting for completion.');
    },
    applyBulkItemStatus(item, rowMap) {
      const row = rowMap.get(item?.requestId);
      if (!row) {
        return;
      }

      const itemStatus = (item?.status || '').toUpperCase();
      if (itemStatus === 'SUCCESS') {
        row.massage = 'Success';
        row.status = 'PROCESSED';
        this.status = true;
        return;
      }

      if (itemStatus === 'FAILED') {
        row.massage = item?.message || 'Failed to process request.';
        row.status = 'ERROR';
        return;
      }

      if (itemStatus === 'PROCESSING') {
        row.massage = 'Processing...';
        row.status = 'PENDING';
        return;
      }

      row.massage = 'Queued...';
      row.status = 'PENDING';
    },
    async approveAllLegacy(selectedData) {
      const url = `${ticketApi2}transaction-handler/approve-user-request`;
      const promises = selectedData.map(async (obj) => {
        const requestBody = {
          id: obj.id,
          approvedBy: this.user.username,
          onlyExpense: false,
          status: 'PENDING',
          errorMessage: "",
        };

        return axios.post(url, requestBody).then(() => {
          requestBody.status = 'PROCESSED';
          obj.massage = 'Success';
          obj.status = 'PROCESSED';
          this.status = true;
        }).catch((error) => {
          try {
            errorHandler.tomcatError(error, true);
          } catch (e) {
            requestBody.status = 'ERROR';
            const mainErrorMessage = e.message.split('\n')[0];
            const shortStackTrace = e.stack.split('\n').slice(1, 4).join('\n');
            requestBody.errorMessage = `${mainErrorMessage}\n${shortStackTrace}`;
            obj.massage = `${mainErrorMessage}\n${shortStackTrace}`;
            obj.status = 'ERROR';
          }
        });
      });

      await Promise.all(promises);
    },
    // GINGER-2026-04-03: Retry failed payment with new local_id
    // TICKET: Founder escalation — users can't retry failed Kazang payments since Mar 26
    // ENDPOINT: POST /transaction-handler/approve-user-request with forceNewLocalId: true
    async retryFailedRequest(item) {
      item.status = 'RETRYING';
      item.massage = 'Retrying with new Local ID...';
      try {
        const url = `${ticketApi2}transaction-handler/approve-user-request`;
        const requestBody = {
          id: item.id,
          approvedBy: this.user.username,
          onlyExpense: false,
          forceNewLocalId: true,
        };
        await axios.post(url, requestBody);
        item.massage = 'Success';
        item.status = 'PROCESSED';
        this.status = true;
        responses.showSuccess('Payment retried successfully!');
      } catch (error) {
        try {
          errorHandler.tomcatError(error, true);
        } catch (e) {
          const msg = e.message.split('\n')[0];
          item.massage = msg;
          item.status = 'ERROR';
          responses.showError('Retry failed: ' + msg);
        }
      }
    },
    isBulkEndpointUnavailable(error) {
      const statusCode = error?.response?.status;
      return statusCode === 404 || statusCode === 405;
    },
    async AcceptRequest(selectedCard) {
      const id = selectedCard.id; // Get the selected request ID
      const approvedBy = this.user.username;
      // Determine the URL based on the active tab
      const url = this.activeTab === 'wallet'
          ? `${ticketApi2}transaction-handler/approve-wallet-request`
          : `${ticketApi2}transaction-handler/approve-user-request`;

      const requestBody = {
        id: id,
        approvedBy: approvedBy,
        onlyExpense: false
      };
      let recipient = selectedCard.requestBy ? selectedCard.requestBy : selectedCard.requestedBy;
      return Swal.fire({
        title: 'Are you sure?',
        text: `You are about to authorize ${$utils.formatMoney(selectedCard.amount)} payment to ${recipient}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showLoaderOnConfirm: !Swal.isLoading(),
        preConfirm: async () => {
          try {
            await axios.post(url, requestBody);
            responses.showInfo(`Request Approved Successfully`);
            return this.filterCards(); // Refresh the card list
          } catch (error) {
            try {
              errorHandler.tomcatError(error, true, `Cannot Accept Request`);
            } catch (e) {
              // Extract the main error message and the first few lines of the stack trace
              const mainErrorMessage = e.message.split('\n')[0]; // Get the first line of the error message
              const shortStackTrace = e.stack.split('\n').slice(1, 4).join('\n'); // Get the next 3 lines of the stack trace
              const formattedError = `${mainErrorMessage}\n${shortStackTrace}`;
              return Swal.showValidationMessage('<pre>' + formattedError + '</pre>');
            }
          }
        }
      })
    },


    storeSelectedWallet() {
      if (this.selectedWallet) {
        // localStorage.setItem('selectedWallet', this.selectedWallet);
        this.$store.commit(`setSelectedWallet`, this.selectedWallet)
      }
    },
    async DenyRequest(selectedCard) {
      return Swal.fire({
        icon: `question`,
        title: `Deny Reason`,
        input: `textarea`,
        showCloseButton: true,
        showCancelButton: true,
        showLoaderOnConfirm: !Swal.isLoading(),
        preConfirm: async (inputValue) => {
          if (!inputValue) return Swal.showValidationMessage(`Reason is Required`);
          const id = selectedCard.id;
          const type = this.activeTab === 'wallet' ? 'WALLET' : 'USER';
          const declinedBy = this.user.username;
          const url = `${ticketApi2}decline`;

          const requestBody = {
            id: id,
            type: type,
            reason: inputValue,
            declinedBy: declinedBy
          };
          try {
            await axios.post(url, requestBody);
            responses.showInfo(`Request Declined Successfully`);
            return this.filterCards(); // Refresh the card list
          } catch (error) {
            try {
              errorHandler.tomcatError(error, true, `Cannot Decline Request`);
            } catch (e) {
              // Extract the main error message and the first few lines of the stack trace
              const mainErrorMessage = e.message.split('\n')[0]; // Get the first line of the error message
              const shortStackTrace = e.stack.split('\n').slice(1, 4).join('\n'); // Get the next 3 lines of the stack trace
              const formattedError = `${mainErrorMessage}\n${shortStackTrace}`;

              // Display the formatted error message in SweetAlert
              return Swal.showValidationMessage(formattedError);
            }
          }
        }
      })
    },
    async viewticket(selectedCard) {
      const ticket = selectedCard.ticket;
      return window.open(`https://hd.chrilantech.com/ticket/${ticket}`)
    },
    async showPhoto(selectedCard) {
      return window.open(ticketApi2 + `getImageByRequestID/${selectedCard.id}`)
    },
    async acceptRequestOnlyExpense(selectedCard) {
      const id = selectedCard.id; // Get the selected request ID
      const approvedBy = this.user.username;
      // Determine the URL based on the active tab
      const url = this.activeTab === 'wallet'
          ? `${ticketApi2}transaction-handler/approve-wallet-request`
          : `${ticketApi2}transaction-handler/approve-user-request`;

      const requestBody = {
        id: id,
        approvedBy: approvedBy,
        onlyExpense: true
      };
      let recipient = selectedCard.requestBy ? selectedCard.requestBy : selectedCard.requestedBy;
      return Swal.fire({
        title: 'Are you sure?',
        html: `You are about to authorize ${$utils.formatMoney(selectedCard.amount)} payment to ${recipient}<br>
        <span class="text-sm text-primary">NB : This will not make the receivers account , just records the expense</span>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showLoaderOnConfirm: !Swal.isLoading(),
        preConfirm: async () => {
          try {
            await axios.post(url, requestBody);
            responses.showInfo(`Request Approved Successfully`);
            return this.filterCards(); // Refresh the card list
          } catch (error) {
            try {
              errorHandler.tomcatError(error, true, `Cannot Accept Request`);
            } catch (e) {
              // Extract the main error message and the first few lines of the stack trace
              const mainErrorMessage = e.message.split('\n')[0]; // Get the first line of the error message
              const shortStackTrace = e.stack.split('\n').slice(1, 4).join('\n'); // Get the next 3 lines of the stack trace
              const formattedError = `${mainErrorMessage}\n${shortStackTrace}`;
              return Swal.showValidationMessage('<pre>' + formattedError + '</pre>');
            }
          }
        }
      })
    },
    async viewPurchaseOrder(selectedCard) {
      const poNumber = selectedCard.purchaseOrder;
      return window.open(`https://tom9.pos.co.zm/PrintApi/creditor/burntofi_chrilan/printPurchaseOrder?id=${poNumber}&User=Auto`)
    },
    async openimage() {
      if (this.selectedCard) {
        const requestId = this.selectedCard.id; // Get the selected request ID
        const url = ticketApi2 + `getImageByRequestID/${requestId}`;

        try {
          const imageData = ticketApi2 + `getImageByRequestID/${requestId}`; // Assume this contains the image data or URL

          if (imageData) {
            // Show the image in a modal or other component
            Swal.fire({
              title: 'Attached Image',
              imageUrl: imageData, // Set the image URL or data
              confirmButtonText: 'OK'
            });
          } else {
            // Show a message if no image is attached
            Swal.fire({
              title: 'No Image Attached',
              text: 'Sorry, no images were attached to this request.',
              icon: 'info',
              confirmButtonText: 'OK'
            });
          }
        } catch (error) {
          return errorHandler.tomcatError(error)
        }
      } else {
        console.error('No card selected.');
        Swal.fire({
          title: 'Error!',
          text: 'Please select a request first.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    },
    async getLoggedInUser() {
      try {
        this.user = await Storage.getCurrentUser();
        let wallets = this.user.wallets;
        let defaultWallet = null;
        if (wallets && wallets.length > 0) {
          let wallet = wallets.find(wal => wal.primary);
          if (wallet) defaultWallet = wallet.id;
        }
        this.$store.commit(`setSelectedWallet`, defaultWallet);
        this.selectedWallet = defaultWallet;
      } catch (error) {
        return errorHandler.tomcatError(error)
      }
    },
    async filterCards() {
      this.$utils.showLoading();

      if (this.isFetching) return; // Prevent multiple calls

      this.isFetching = true; // Set fetching flag

      try {
        if (this.selectedWallet) {
          const response = await axios.get(ticketApi2 + `getRequestsByWallet`, {
            params: {
              name: this.selectedWallet,
              department: this.selectedDepartment,
              office: this.selectedOffice,
            }
          });
          this.cardData.wallet = response.data.walletRequestResponses;
          this.cardData.user = response.data.userRequestResponseList;
          if (this.activeTab === 'wallet') {
            this.filteredCardData = this.cardData.wallet;
          } else {
            this.filteredCardData = this.cardData.user;
            console.log(this.filteredCardData);
          }
        } else {
          this.filteredCardData = [];
        }
        console.log(this.filteredCardData);
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        this.storeSelectedWallet();
        this.$utils.hideLoading();
        this.isFetching = false; // Reset fetching flag
      }
    },

    logNumber(number) {
      console.log(number);
    },

    async refillVueTable() {
      this.$utils.showLoading();

      if (this.isFetching) return; // Prevent multiple calls

      this.isFetching = true; // Set fetching flag

      try {
        if (this.selectedWallet) {
          const response = await axios.get(ticketApi2 + `getRequestsByWallet`, {
            params: {
              name: this.selectedWallet,
              department: this.selectedDepartment,
              office: this.selectedOffice,
            }
          });
          this.cardData.wallet = response.data.walletRequestResponses;
          this.cardData.user = response.data.userRequestResponseList;
          if (this.activeTab === 'wallet') {
            this.refillTableData = this.cardData.wallet;
          } else {
            this.refillTableData = this.cardData.user;
            this.refillTableData = this.refillTableData.map(obj => ({
              ...obj,
              massage: "", // flag
            }))
            console.log(this.refillTableData);
          }
        } else {
          this.refillTableData = [];
        }
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        this.storeSelectedWallet();
        this.$utils.hideLoading();
        this.isFetching = false; // Reset fetching flag
      }
    },
    async setTab(tab) {
      this.activeTab = tab;
      this.filterCards(); // Update cards based on selected tab
    },
    selectCard(item) {
      this.selectedCard = item;
      document.getElementById(`openCard`).click();
    },
    setFallbackImage(event) {
      event.target.src = '/img/no-image.png';
    },
  },
  watch: {
    selectedIds(newVal) {
      // Keep "Select All" checkbox in sync with individual selections
      this.selectAll =
          newVal.length === this.refillTableData.length &&
          this.refillTableData.length > 0;
    },
  },
  mounted() {
    this.filterCards();
    this.checkMobileView();
    window.addEventListener("resize", this.checkMobileView);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobileView);
  }
};
</script>
<style scoped lang="scss">
.flexy {
  display: flex;
  justify-content: center;
  align-items: center;
}
.manager {
  width: 100%;
  height: fit-content;
  border-radius: 5px;
  background-color: #1d90dd;
  color: white;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.h6-tag {
  margin-top: 5px;
  font-weight: 600;
}
.total {
  width: fit-content;
  display:flex;
  justify-content: center;
  align-items:center;
  gap: 10px
}
.form-container {
  position: relative;
}
.attention-required {
  color: #ff3c00;
  font-weight: bold;
  animation: flash 1s infinite;
}

@keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
}

.hide {
  display: none;
}

.page {
  height: 85vh;
  overflow-y: scroll !important;
  overflow-X: hidden !important;
}

.hidden {
  display: none; /* This will hide the button completely */
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tabs {
  display: flex;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.tabs button {
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f8f9fa;
  color: #333;
  padding: 0.5rem 1rem;
  margin-right: 1rem;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.tabs button.active {
  background-color: #007bff;
  color: white;
}

.modal-backdrop {
  z-index: -2 !important;
}


/*===== VARIABLES CSS =====*/
:root {
  --dark-color-lighten: #f2f5ff;
  --red-card: #a62121;
  --blue-card: #4bb7e6;
  --btn: #141414;
  --btn-hover: #3a3a3a;
  --text: #fbf7f7;
}

/*===== CARD =====*/
.container {
  width: 100%;
  max-width: 850px;
  margin: 2rem auto;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

.card {
  position: relative;
  padding: 1rem;
  width: 300px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 0.9rem;
  background-color: var(--red-card);
  color: var(--text);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.3s ease;
}

.card-blue {
  background: var(--blue-card);
}

.product-image {
  height: 140px;
  width: 100%;
  overflow: hidden;
  transform: translateY(0);
  transition: transform 500ms ease-in-out;
  filter: drop-shadow(5px 10px 15px rgba(0, 0, 0, 0.3));
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  margin: 0 auto;
}

.card:hover .product-image {
  transform: translateY(-10px) rotate(-3deg);
}

.product-info {
  text-align: center;
}

.product-info h2 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-info p {
  margin: 0.2rem 0;
  font-size: 0.9rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.price {
  font-size: 20px;
  font-weight: 600;
}

.card-body {
  text-align: left;
  font-size: 0.9rem;
  line-height: 1.4;
}

.btn {
  display: flex;
  justify-content: space-between;
  margin-top: 0.8rem;
}

.buy-btn {
  background-color: var(--btn);
  padding: 0.5rem 1rem;
  font-weight: 600;
  font-size: 1rem;
  transition: background-color 300ms ease;
}

.buy-btn:hover {
  background-color: var(--btn-hover);
}

.fav {
  background: #fff;
  padding: 0.5rem;
  border: 1px solid #000;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg {
  height: 25px;
  width: 25px;
  fill: #fff;
  transition: fill 500ms ease;
}

.fav:hover .svg {
  fill: #000;
}

@media screen and (max-width: 768px) {
  .total {
    width: fit-content;
    display:flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items:center;
    gap: 10px
  }
  .container {
    padding: 1rem;
    flex-direction: column;
  }

  .card {
    width: 90%;
  }

  .product-image {
    height: 150px;
  }
}

.row {
  margin-left: 12px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal Content */
.modal-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 5px;
  border-radius: 8px;
  text-align: center;
  width: 95%;
  max-width: 95%;
  max-height: 99vh;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.modal-bodyy {
  flex: 1; /* Makes the body take up remaining space */
  overflow-y: auto; /* Enables vertical scrolling */
  padding: 1rem;
  width: 100%;
}
.modal-header {
  position: sticky;
  top: 10px;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1000;
}

.div-class {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 400px;
  height: 100px;
  background: aliceblue;
  margin-bottom: 10px;
}

.img {
  width: 40px;
  height: 40px;
}
.card-container {
  width: 100%;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);  /* Semi-transparent overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;  /* Ensure it covers the form */
  pointer-events: all;  /* Block interactions */
}
.dots-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.dot {
  height: 20px;
  width: 20px;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #b3d4fc;
  animation: pulse 1.5s infinite ease-in-out;
}

.dot:last-child {
  margin-right: 0;
}

.dot:nth-child(1) {
  animation-delay: -0.3s;
}

.dot:nth-child(2) {
  animation-delay: -0.1s;
}

.dot:nth-child(3) {
  animation-delay: 0.1s;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }

  50% {
    transform: scale(1.2);
    background-color: #6793fb;
    box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);
  }

  100% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }
}

.filter {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>


